// extracted by mini-css-extract-plugin
export default {"root":"StatusTabs_root__7pCTz","tab":"StatusTabs_tab__Q7i8A","selected":"StatusTabs_selected__2ueyh","count":"StatusTabs_count__HPkjq"};